<!-- 由 Dioa 创建于 2023-05-05 星期五 -->
<template>
  <van-divider>{{ propValue }}</van-divider>
</template>

<script>
export default {
  name: 'index',

  components: {},

  props: {
    propValue: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped></style>
